/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PWA } from '../model';
/**
 * PWAApi - axios parameter creator
 * @export
 */
export const PWAApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the PWA details
         * @param {string} pwaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pwaRetrieve: async (pwaId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'pwaId' is not null or undefined
            assertParamExists('pwaRetrieve', 'pwaId', pwaId)
            const localVarPath = `/v2/pwa/{pwa_id}`
                .replace(`{${"pwa_id"}}`, encodeURIComponent(String(pwaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PWAApi - functional programming interface
 * @export
 */
export const PWAApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PWAApiAxiosParamCreator(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the PWA details
         * @param {string} pwaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pwaRetrieve(pwaId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PWA>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pwaRetrieve(pwaId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PWAApi - factory interface
 * @export
 */
export const PWAApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PWAApiFp(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Fetch the PWA details
         * @param {string} pwaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pwaRetrieve(pwaId: string, options?: any): AxiosPromise<PWA> {
            return localVarFp.pwaRetrieve(pwaId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for pwaRetrieve operation in PWAApi.
 * @export
 * @interface PWAApiPwaRetrieveRequest
 */
export interface PWAApiPwaRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof PWAApiPwaRetrieve
     */
    readonly pwaId: string
}

/**
 * PWAApi - object-oriented interface
 * @export
 * @class PWAApi
 * @extends {BaseAPI}
 */
export class PWAApi extends BaseAPI {
    /**
     * Allow external IDs to be used for generic API views.
     * @summary Fetch the PWA details
     * @param {PWAApiPwaRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PWAApi
     */
    public pwaRetrieve(requestParameters: PWAApiPwaRetrieveRequest, options?: any) {
        return PWAApiFp(this.configuration).pwaRetrieve(requestParameters.pwaId, options).then((request) => request(this.axios, this.basePath));
    }
}
